import { Delete } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import MyBadge from "components/shared/MyBadge";
import tables from "components/shared/Tables/table.module.scss";
import theme from "components/utils/theme";


export const permissionGroups = [
    {
        name: 'Device Access Control',
        permissions: [
            'ENROLL_DEVICE',
            'DELETE_DEVICE',
            'VIEW_DEVICE_DETAILS'
        ]
    },
    // {
    //     name: 'Network Access Control',
    //     permissions: [
    //         'ADD_NETWORK',
    //         'DELETE_NETWORK',
    //         'VIEW_NETWORK_DETAILS',
    //         'UPDATE_NETWORK_CREDENTIALS',
    //         'ALLOW_NETWORK_RESCAN'
    //     ]
    // },
    {
        name: 'Device Details',
        permissions: [
            'VIEW_DEVICE_LOCATION',
            'VIEW_SYSTEM_DETAILS',
            'VIEW_NETWORK_INTERFACES',
            'VIEW_NETWORK_PORTS',
            'KILL_PORT',
            'VIEW_RUNNING_PROCESSES',
            'KILL_PROCESS',
            'VIEW_INSTALLED_APPLICATIONS',
            // 'UNINSTALL_APPLICATION',
            'VIEW_FILE_INTEGRITY_MANAGEMENT',
            'VIEW_ALERTS',
            'VIEW_ANOMALIES',
            'VIEW_DEVICE_USERS',
            'ADD_DEVICE_USER'
        ]
    },
    {
        name: 'Portal Access Management',
        permissions: [
            "VIEW_PORTAL_MANAGEMENT",
            'VIEW_PORTAL_GROUPS',
            'CREATE_PORTAL_GROUPS',
            'DELETE_PORTAL_GROUPS',
            'EDIT_PORTAL_GROUPS',
            'VIEW_PORTAL_USERS',
            'INVITE_PORTAL_USERS',
            'ASSIGN_PORTAL_USER_TO_GROUP',
            'VIEW_ROLES',
            'CREATE_ROLES',
            'DELETE_ROLES',
            'ASSIGN_ROLE_TO_GROUP'
        ]
    },
    {
        name: 'Assets Management',
        permissions: [
            "VIEW_ASSET_MANAGEMENT",
            'VIEW_ASSET_GROUPS',
            'CREATE_ASSET_GROUPS',
            'DELETE_ASSET_GROUPS',
            'EDIT_ASSET_GROUPS',
            'VIEW_EMPLOYEES',
            'ADD_EMPLOYEES',
            'DELETE_EMPLOYEES',
            'ASSIGN_EMPLOYEES_TO_GROUP',
            'ASSIGN_DEVICE_TO_GROUP',
            'VIEW_ALERT_POLICY',
            'ADD_ALERT_POLICY',
            'REMOVE_ALERT_POLICY',
            'ASSIGN_ALERT_POLICY_TO_GROUP'
        ]
    },
    {
        name: 'Settings',
        permissions: [
            'NOTIFICATIONS',
            'VIEW_AUTHENTICATION',
            'UPDATE_AUTHENTICATION',
            'VIEW_BILLING',
            'CANCEL_MEMBERSHIP'
        ]
    },
    {
        name: 'Remote Access Control',
        permissions: [
            'ACCESS_SINGLE_DEVICE_CONSOLE',
            'ACCESS_MULTI_DEVICE_CONSOLE'
        ]
    }
];


export const getAlertColumns = ({ handleDeleteAlertPolicyOpen, isDeleteAllowed }) => {
    return [
        { field: "policyName", headerName: "Policy Name", flex: 1 },
        { field: "type", headerName: "Type", flex: 1 },
        { field: "osPlatform", headerName: "OS Platform", flex: 1 },
        {
            field: "details",
            headerName: "Details",
            minWidth: 100,
            flex: 3,
            renderCell: (params) => (
                <Box sx={{ maxWidth: "100%", overflowX: "auto", display: "flex" }}>
                    <Box sx={{ minWidth: "fit-content" }}>
                        {params.row.details.map((detail, index) => (
                            <Button
                                key={index}
                                variant="outlined"
                                className={tables.actionBtn}
                                size="small"
                                sx={{ marginRight: 1, whiteSpace: "nowrap" }}
                            >
                                {detail}
                            </Button>
                        ))}
                    </Box>
                </Box>
            ),
        },
        {
            field: "size",
            headerName: "Alert Level",
            flex: 1,
            renderCell: (params) => {
                return getAccessBadge(params.row.alertLevel);
            },
        },
        isDeleteAllowed && {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            renderCell: (params) => (
                <IconButton
                    onClick={(event) => {
                        event.stopPropagation();
                        handleDeleteAlertPolicyOpen(params.row._id);
                    }}
                >
                    <Delete />
                </IconButton>
            ),
        },
    ];
}

export const ALERT_POLICY_DOWNLOAD_COLS = [
    { field: "policyName", headerName: "Policy Name" },
    { field: "type", headerName: "Type" },
    { field: "osPlatform", headerName: "OS Platform" },
    { field: "alertLevel", headerName: "Alert Level" },
    { field: "details", headerName: "Details" },
];


export const getAccessBadge = (type) => {
    switch (type) {
        case 'High':
            return <MyBadge
                title={"High"}
                bgColor={theme.palette.error.main}
                txtColor={theme.palette.white.main}
            />
        case "Medium":
            return <MyBadge
                title={"Medium"}
                bgColor={theme.palette.warning.main}
                txtColor={theme.palette.white.main}
            />
        case "Low":
            return <MyBadge
                title={"Low"}
                bgColor={theme.palette.success.main}
                txtColor={theme.palette.white.main}
            />
        default:
        //someting
    }

};
